import { useQuery } from '@tanstack/react-query';

import ApiProduct from '@Api/Product';
import { useRequest } from '@Contexts/Request';

interface ProductSellPointsData {
  productId: number;
}

function useProductSellPoints({ productId }: ProductSellPointsData) {
  const { region } = useRequest();
  const keys = [productId, { region }];

  const { data } = useQuery({
    queryKey: keys,
    queryFn: () => ApiProduct.getProductSellPoint(productId),
    enabled: true,
  });

  return data;
}

export default useProductSellPoints;
